import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useModalStore } from '@/store/modalStore';
import { useTokenStore } from '@/store/tokenStore';

import * as S from './style.ts';

const MembershipGuide: React.FC = () => {
	const navigate = useNavigate();
	const { isLogin } = useTokenStore();
	const { showModal } = useModalStore();

	const onClickSignUp = () => {
		if (isLogin()) {
			showModal('이미 화장품학회 회원이십니다.', 'confirm');
			return;
		} else {
			navigate('/auth/signup');
			return;
		}
	};

	return (
		<S.Container>
			<S.ContentBox>
				<S.ContentTitle>회원구분</S.ContentTitle>
				<S.Table className="table1">
					<S.TableHeadCell className="center">구분</S.TableHeadCell>
					<S.TableHeadCell className="center">자격</S.TableHeadCell>

					<S.TableCell className="min-height point center">정회원</S.TableCell>
					<S.TableCell className="min-height center">
						대학, 연구기관, 기업 등에서 화장품과 관련된 연구, 생산⋅개발업무 등에 종사하고 있는 자로 소정의 연회비를 납부한 자
					</S.TableCell>

					<S.TableCell className="min-height point center">일반회원</S.TableCell>
					<S.TableCell className="min-height center">본 학회의 목적에 관련된 분야에 종사하고 있는 자로 화장품 과학에 관심있는 자</S.TableCell>

					<S.TableCell className="min-height point center">학생회원</S.TableCell>
					<S.TableCell className="min-height center">
						본 학회의 목적에 관련된 분야의 교육을 실시하고 있는 전문대학 이상의 학교에서 재학하고 있는 학생
					</S.TableCell>

					<S.TableCell className="min-height point center">명예회원</S.TableCell>
					<S.TableCell className="min-height center">본 학회의 목적에 관하여 탁월한 공적이 있는 자 또는 본 학회의 발전에 크게 기여한 자</S.TableCell>

					<S.TableCell className="min-height point center">특별회원</S.TableCell>
					<S.TableCell className="min-height center">본 학회의 사업을 지원하기 위해서 국내·외의 단체 또는 법인으로 특별회비를 납부하는 자</S.TableCell>
				</S.Table>
				<S.GuideBox>
					<S.GuideTextStrong>본 학회 학생회원 기준 : 학부생 ~ 석사과정생까지</S.GuideTextStrong>
					<S.GuideText>
						Part time은 일반회원으로 되며, 석박통합의 경우 5학기부터는 일반회원입니다.
						<br />
						<br />
						[일반회원 → 학생회원으로 변경 절차]
						<br />
						회원가입 후 로그인 → My → 재학인증 → 재학증명서 업로드 → 등록
						<br />
						추후 학회 사무국에서 재학증명서 확인 후 학생회원으로 변경진행
						<br />
						(재학증명서 업로드 후 학회 사무국 scsk1968@naver.com 메일 발송)
					</S.GuideText>
				</S.GuideBox>
			</S.ContentBox>

			<S.ContentBox>
				<S.ContentTitle className="center">연회비</S.ContentTitle>
				<S.Table className="table3">
					<S.TableHeadCell className="center">구분</S.TableHeadCell>
					<S.TableHeadCell className="center">일반회원</S.TableHeadCell>
					<S.TableHeadCell className="center">학생회원</S.TableHeadCell>

					<S.TableCell className="center point">연회비(2026년)</S.TableCell>
					<S.TableCell className="min-height center">200,000원</S.TableCell>
					<S.TableCell className="min-height center">100,000원</S.TableCell>
				</S.Table>
			</S.ContentBox>

			<S.ContentBox>
				<S.ContentTitle>회원의 권리와 의무</S.ContentTitle>

				<S.ContentItems>
					<S.ContentListLayout>
						<S.ContentTitleSub>01</S.ContentTitleSub>
						<S.ContentDescription>본 학회의 회원은 소정의 회비를 납부함으로써 정관 및 규정에 의한 권리와 의무를 갖는다.</S.ContentDescription>
					</S.ContentListLayout>

					<S.ContentListLayout>
						<S.ContentTitleSub>02</S.ContentTitleSub>
						<S.ContentDescription>
							모든 회원은 총회를 통하여 본 학회의 운영에 참여할 권리를 가진다.다만 일반회원, 학생회원, 명예회원, 특별회원은 총회에 출석하여 발언 할 수 있으나
							의결권은 없으며, 선거권 및 피선거권은 정회원만이갖는다.
						</S.ContentDescription>
					</S.ContentListLayout>

					<S.ContentListLayout>
						<S.ContentTitleSub>03</S.ContentTitleSub>
						<S.ContentDescription>모든 회원은 총회 및 이사회의 결의를 준수해야 한다.</S.ContentDescription>
					</S.ContentListLayout>

					<S.ContentListLayout>
						<S.ContentTitleSub>04</S.ContentTitleSub>
						<S.ContentDescription>
							본 학회의 정회원 자격은 연회비를 납부한 자로 하며, 정회원이 소정의 회비를 납부하지 않은 경우 회원자격이 정지되고, 자격정지 발효 후 연회비를
							납부하는 경우 정회원으로서의 자격이 회복된다.단, 명예회원은 회비를 면제할 수 있다.
						</S.ContentDescription>
					</S.ContentListLayout>
				</S.ContentItems>
			</S.ContentBox>

			<S.ContentBox>
				<S.ContentTitle>회원의 탈퇴</S.ContentTitle>

				<S.ContentDescription>본 회의 회원 임의로 탈퇴할 수 있습니다. 다만 납입된 회비 등은 반환되지 않습니다.</S.ContentDescription>
			</S.ContentBox>

			<S.ContentBox>
				<S.ContentTitle>회원가입</S.ContentTitle>
				<S.ContentItems>
					<S.ContentDescription>회원가입을 원하시면 아래 회원가입 버튼을 눌러주세요.</S.ContentDescription>
					<S.Button onClick={onClickSignUp}>회원가입 하기</S.Button>
				</S.ContentItems>
			</S.ContentBox>
		</S.Container>
	);
};

export default MembershipGuide;
